import VueTk from 'vue-tk'
import store from '../store/index'
export default new Promise(async function (resolve) {
  if (!store.state.sessionToken || !store.state.user) {
    resolve()
    return false
  }
  VueTk.$tkAjaxGlobal.headers['X-Parse-Session-Token'] = store.state.sessionToken
  let user = await VueTk.tkParse.getData('/users/me').catch(() => {
    VueTk.$tkAjaxGlobal.headers['X-Parse-Session-Token'] = ''
  })
  if (user) store.commit('setUser', user)
  resolve()
})



// WEBPACK FOOTER //
// ./src/init/userInit.js